import React from 'react';
import { Container, Paper, Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import LoginImage from "../../../assets/images/background_login.jpg";
import { ReactComponent as Logo } from '../../../assets/svg/flo-logo.svg';
import AuthRoutes from '../AuthRoutes';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "7em",
    height: "40em",    
    [theme.breakpoints.down('sm')]: {
      marginTop: "1em",
    },
  },  
  paperStyle: {
    height: "100%"
  },

  imageContainer:{
    backgroundImage: `url(${LoginImage})`,
    height: "40em",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    [theme.breakpoints.down('sm')]: {
      height: "4em",
    },
  },
  logo: {
    width: "15em",
    height: "10em",
    [theme.breakpoints.down('sm')]: {
      width: "15em",
      height: "2em",
    },
  },
  form: {
    padding: "5em",
    [theme.breakpoints.down('sm')]: {
      padding: "2.5em",
    },
  }
}));

function Auth() {
  const classes = useStyles();

  return (
    <Container maxWidth={'lg'} className={classes.root}>             
      <Paper elevation={3} className={classes.paperStyle}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
        >
           <Grid container item md={7} >
              <div className={classes.imageContainer}>
                <Logo className={classes.logo}/>
              </div>
           </Grid>

           <Grid container item md={5} >              
                <Grid
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="stretch"
                  // style={{padding: "5em"}}
                  className={classes.form}
                >
                  <AuthRoutes className={classes.containerPage}/>
                </Grid>              
           </Grid>
        </Grid>
      </Paper>      
    </Container>
  )
}

export default Auth;